import Vue from 'vue';

// Zwischenspeicher: Schlüssel aus Icon/Größe/Klasse/Style → fertiger SVG-String
const cache = new Map();

// Wandelt ein lucide-vue-Icon in einen SVG-String um, z. B. lucideHtml(Check, { size: 20, class: 'text-success' })
// Gedacht für Stellen, die HTML-Text statt Vue-Komponenten erwarten: AG-Grid-cellRenderer als Funktion,
// Set-Filter-Renderer, Tooltip-HTML, innerHTML
// Farbe läuft über currentColor, Utility-Klassen wie text-success/text-danger färben das Icon also direkt
// Jede Kombination wird nur einmal gerendert und danach aus dem Cache geliefert, da Grids pro Zelle aufrufen
export function lucideHtml(icon, { size = 16, class: className, style } = {}) {
  const key = `${icon.name}|${size}|${className ?? ''}|${JSON.stringify(style ?? '')}`;
  if (cache.has(key)) return cache.get(key);

  // Unsichtbare Vue-Instanz rendert das Icon einmalig, das erzeugte <svg> wird als Text übernommen
  const vm = new Vue({
    render: h => h(icon, { props: { size }, class: className, style }),
  }).$mount();
  const html = vm.$el.outerHTML;
  vm.$destroy();
  cache.set(key, html);
  return html;
}
